import { gql } from "@apollo/client";

export const STREAM_RERUN = gql`
  mutation streamReRun($id: Int!) {
    streamReRun(id: $id) {
      id
      message
      isError
    }
  }
`;
